import script from "./ListProductVariants.vue?vue&type=script&setup=true&lang=ts"
export * from "./ListProductVariants.vue?vue&type=script&setup=true&lang=ts"

import "./ListProductVariants.vue?vue&type=style&index=0&id=58485362&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58485362"]])

export default __exports__